import type { Vector3Data } from "../types/astronomy";

/**
 * Mapeamento astronômico → Three.js:
 * - Plano eclíptico em XZ
 * - Y perpendicular à eclíptica
 * threeX = astronomicalX
 * threeY = astronomicalZ
 * threeZ = astronomicalY
 */
export function astronomicalToThree(positionKm: Vector3Data): Vector3Data {
  return {
    x: positionKm.x,
    y: positionKm.z,
    z: positionKm.y,
  };
}

export function threeToAstronomical(position: Vector3Data): Vector3Data {
  return {
    x: position.x,
    y: position.z,
    z: position.y,
  };
}

export function rotateAroundX(vector: Vector3Data, angleRad: number): Vector3Data {
  const cos = Math.cos(angleRad);
  const sin = Math.sin(angleRad);
  return {
    x: vector.x,
    y: vector.y * cos - vector.z * sin,
    z: vector.y * sin + vector.z * cos,
  };
}

export function rotateAroundZ(vector: Vector3Data, angleRad: number): Vector3Data {
  const cos = Math.cos(angleRad);
  const sin = Math.sin(angleRad);
  return {
    x: vector.x * cos - vector.y * sin,
    y: vector.x * sin + vector.y * cos,
    z: vector.z,
  };
}
